<div class="wrapper">
  <p-button-pure
    [hideLabel]="true"
    [iconSource]="'assets/icons/refresh.svg'"
    [size]="'large'"
    [type]="'button'"
    (click)="click.emit()"
  >
    {{ label }}
  </p-button-pure>
</div>
